import {connect} from "react-redux";
import ActivityFeedModalComponent from "../modal/components/ActivityFeedModalComponent";
import {RouteComponentProps} from "react-router";
import {feedModelSelector, feedSelector} from "../selectors";
import {MouseEvent} from "react";
import {PrimaryModels} from "../../_definitions/styleteq";
import {toggleLike} from "../../_data/middlewares";
import {History} from "history";
import {UsersRoutes} from "../../routes";

interface Props {
    id: number;
    history: History,
    currentUserID: number;
}

const mapStateToProps = (state, props: Props) => {
    const feed = feedSelector(state, props.id);
    return {
        model: feedModelSelector(state, feed)
    };
};

const mapDispatchToProps = (dispatch, {currentUserID}:Props) => {
    return {
        toggleLike: (e: MouseEvent<HTMLElement>, model: PrimaryModels) => {
            e.stopPropagation();
            if (!currentUserID)
                return window.location.replace(UsersRoutes.sign_in());
            dispatch(toggleLike(model));
        }
    };
};

const ActivityFeedModalContainer = connect(mapStateToProps, mapDispatchToProps)(ActivityFeedModalComponent);
export default ActivityFeedModalContainer;


// WEBPACK FOOTER //
// ./app/client/activityFeeds/containers/ActivityFeedModalContainer.tsx